import { render, staticRenderFns } from "./RecommendedColumn.vue?vue&type=template&id=662d03a4"
import script from "./RecommendedColumn.vue?vue&type=script&lang=js"
export * from "./RecommendedColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports